import { EditAltIcon, DeleteIcon, RmxCheckIcon } from 'cokitchen-icons';
import React, { useState, useCallback } from 'react';
import useSettingsContext from 'contexts/settings.context/context';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import EditableInput from 'components/base/editable-input';

const USER_HEADERS = ['First Name', 'Last Name', 'Email', 'Phone Number', 'Role', 'Actions'];

const ReviewUserDetails = () => {
  const { userFormData, setUserFormData, roles } = useSettingsContext();
  const [editingRows, setEditingRows] = useState<Record<number, boolean>>({});

  const handleChange = (field: string, value: string, index: number) => {
    setUserFormData((prev) =>
      prev.map((itm, i) => (i === index ? { ...itm, [field]: value } : itm))
    );
  };

  const removeUser = (index: number) => {
    setUserFormData((prev) => prev.filter((item, i) => index !== i));
  };

  const toggleEdit = useCallback((index: number) => {
    setEditingRows((prev) => ({ ...prev, [index]: !prev[index] }));
  }, []);

  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Review user details</h3>
      </div>

      <Table headers={USER_HEADERS}>
        {userFormData?.map((user, index) => {
          const isEditing = editingRows[index] || false;

          return (
            <TableRow key={index} className='hover:bg-gray-50 transition-colors'>
              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing={isEditing}
                  showError
                  value={user.first_name}
                  onChange={(e) => handleChange('first_name', e.target.value, index)}
                  placeholder='First name'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing={isEditing}
                  value={user.last_name}
                  showError
                  onChange={(e) => handleChange('last_name', e.target.value, index)}
                  placeholder='Last name'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  type='email'
                  isEditing={isEditing}
                  value={user.email}
                  showError
                  onChange={(e) => handleChange('email', e.target.value, index)}
                  placeholder='Email'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing={isEditing}
                  value={user.phone_number}
                  showError
                  onChange={(e) => handleChange('phone_number', e.target.value, index)}
                  type='tel'
                  placeholder='Phone number'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <div className={`${user.role.name ? '' : 'border border-red-5'}`}>
                  {isEditing ? (
                    <SelectDropdown
                      placeholder='Select role'
                      value={user.role.name}
                      setValue={(role) => {
                        handleChange('role', role, index);
                      }}
                      options={roles}
                    />
                  ) : (
                    <span className='text-sm'>{user.role.name || '-'}</span>
                  )}
                </div>
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <div className='flex items-center justify-center gap-2'>
                  {isEditing ? (
                    <div className='cursor-pointer text-green-6' onClick={() => toggleEdit(index)}>
                      <RmxCheckIcon />
                    </div>
                  ) : (
                    <div className='cursor-pointer text-blue-5' onClick={() => toggleEdit(index)}>
                      <EditAltIcon />
                    </div>
                  )}
                  {userFormData.length > 1 && (
                    <div className='cursor-pointer text-red-5' onClick={() => removeUser(index)}>
                      <DeleteIcon />
                    </div>
                  )}
                </div>
              </TableData>
            </TableRow>
          );
        })}
      </Table>
    </div>
  );
};

export default ReviewUserDetails;
